import { useState } from "react";
import { Button } from "../../../components/Button/Button.tsx";
import { useAppMutation } from "../../../http/useAppMutation.ts";
import { useWorkspace } from "../../hooks/useWorkspace.ts";
import { SettingsContentLayout } from "./components/SettingsContentLayout.tsx";
import { SettingsTextItem } from "./components/SettingsTextItem.tsx";
import { MAIL_TO } from "./constants.ts";

export const WorkspaceGeneralSettings = ({
  onUpdate,
}: {
  onUpdate: () => void;
}) => {
  const { workspace } = useWorkspace();
  const [name, setName] = useState(workspace.name);
  const {
    mutate: workspaceInformationMutate,
    isLoading: isWorkspaceInformationMutationLoading,
  } = useAppMutation({
    path: `workspaces/${workspace.uuid}`,
    invalidate: [`workspaces/${workspace.uuid}`, "users/me"],
  }).mutation;

  return (
    <SettingsContentLayout
      header={<div className="label-lg-semibold text-primary">General</div>}
      items={[
        <div key="name" className="flex-col">
          <SettingsTextItem title="Name" value={name} onChange={setName} />
          <div className="py-200 flex-row items-center justify-end gap-200">
            <Button
              size="md"
              variant="secondary"
              loading={isWorkspaceInformationMutationLoading}
              disabled={!name || workspace.name === name}
              onClick={() =>
                workspaceInformationMutate(
                  {
                    name,
                  },
                  {
                    onSuccess: onUpdate,
                  },
                )
              }
            >
              Save changes
            </Button>
          </div>
        </div>,
        <div key="deletion">
          <a
            className="body-md-semibold text-error-secondary underline"
            href={MAIL_TO + "?subject=Delete my workspace"}
            target="_blank"
          >
            Request workspace deletion
          </a>
        </div>,
      ]}
    />
  );
};
